import React from "react";
import { WizardScreen } from "./view";
import { WizardController } from "./controller";
import { styles } from "./styles";

export class Wizard extends React.Component {
  static navigationOptions = {
    title: "Wizard"
  };

  constructor(props) {
    super(props);
    this.controller = new WizardController(props);
  }

  render() {
    return (
      <WizardScreen
        {...this.props}
        controller={this.controller}
        styles={styles}
      />
    );
  }
}
